import { URLS } from 'constants/api.constants';
import { axiosInstance } from 'utils/axios';

const { createAsyncThunk } = require('@reduxjs/toolkit');

export const createContact = createAsyncThunk(
  'create/contact',
    async ({ full_name, email, subject, message }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(URLS.CONTACT.CREATE_CONTACT, {
        full_name,
        email,
        subject,
        message,
      });
      // if (response?.data?.success) {
      return response?.data;
      // }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
export const getContactInfo = createAsyncThunk(
  'fetch/contact',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(URLS.CONTACT.GET_CONTACT_INFO);
      if (response?.data?.success) {
        return response?.data;
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
